<template>
	<div class="p-grid">
		<div class="p-col-12" style="margin-top: 10px">
			<p class="login-text" style="color: lightgray; font-weight: bold; text-align: center; margin-top: 50px;">Trusted by individuals and teams</p>
			<img :src="commonService.getHomeTeamsImageUrl()" alt="" style="width: 100%">
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
};
</script>

<style scoped>

.login-text {
	margin-top: 10px;
	font-size: 22px;
}

</style>